Postlogin.Avatars = (function () {
    const init = function () {
        const grid = new Muuri('ul.avatars', {
            element: 'li.avatar',
            dragEnabled: true,
            dragReleaseDuration: 0,

            // Layout
            layout: {
                fillGaps: true,
                horizontal: false,
                alignRight: false,
                alignBottom: false,
                rounding: false,
            },
            layoutOnResize: 150,
            layoutOnInit: true,
            layoutDuration: 300,
            layoutEasing: 'ease',
        });

        grid.on('dragEnd', () => {
            const order = grid.getItems().map((item) => item.getElement().getAttribute('data-avatar-id'));

            $.post(
                `${window.location.href.split('#')[0].replace(/\/?$/, '/')}saveOrder/`,
                {
                    order,
                },
                (data) => {
                    const notificationParams = {
                        text: data.data.message,
                        time: 3000,
                        type: 'success',
                    };

                    VjsUtility.Notification.init(notificationParams);
                },
            );
        });
    };

    return {
        init,
    };
}());
